import logo from './logo.svg';
import './App.css';
import QuizTrigger from './components/QuizTrigger/QuizTrigger';

function App() {
  return (
    <div className="App">
      <QuizTrigger />
    </div>
  );
}

export default App;
